import React, { useContext } from "react";
import { Link } from "react-router-dom";

//assets
import { TvLogoFull, TvLogoIcon } from "../../../../assets/BrandLogo";
import { ReactComponent as MESSAGE_ICON } from "../../../../assets/images/message.svg";
import ChatBox from "../../ChatBox/ChatBox";

import { AppContext } from "../../../../context/AppContext";
import Button from "../../../Common/Buttons/Button";
import RegisterModal from "../../../Common/Modals/RegisterModal";
import AccountButton from "../AccountButton/AccountButton";
// import CashierModal from "./CashierModal/CashierModal";
import CashierModal from "../../../Modals/CashierModals/CashierModal";
import SearchModal from "../../../Modals/SearchModal/SearchModal";
import RewardsButton from "../RewardsButton/RewardsButton";
import TotalMoneyContainer from "../TotalMoneyContainer";
import { StyledNavBar } from "./styles";
import { useAuth } from "@/context/AuthContext";
import { formatCoins } from "@/lib/coins";

const NavBar = () => {
  const { isChatBoxOpen, isMobileScreen, isTabletScreen, updateChatBox } =
    useContext(AppContext);

  const { user } = useAuth();
  const displayBalance = formatCoins(user?.balance ?? user?.profile?.balance ?? 0);

  return (
    <StyledNavBar>
      <div
        className="h-16 flex justify-between items-center p-3"
        style={{
          boxShadow: "2px 2px 2px rgba(0,0,0,0.3)",
          position: "fixed",
          top: "0",
          left: "0",
          right: "0",
          background: "#1A1D29",
          zIndex: 11,
        }}
      >
        <div
          className={`logo-container ${
            isTabletScreen ? "logo-container-mobile" : ""
          }`}
        >
          <Link to="/ " className="flex h-10 flex-shrink-0 cursor-pointer">
            {isMobileScreen ? <TvLogoIcon size={36} /> : <TvLogoFull height={36} />}
          </Link>
          {/* Rewards Button */}
          {user?.profile && (
            <div className="money-container">
              {isTabletScreen && !isMobileScreen ? (
                <TotalMoneyContainer money={displayBalance} />
              ) : null}
              <RewardsButton />
            </div>
          )}
        </div>

        {user?.profile && (
          <>
            {/* Coins / Cashier / Buy Crypto Section */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              {!isTabletScreen && (
                <>
                  <TotalMoneyContainer money={displayBalance} />

                  <CashierModal button="Get Coins" />
                </>
              )}
            </div>
          </>
        )}

        <div style={{ display: "flex", alignItems: "center" }}>
          {!user?.profile && (
            <>
              <RegisterModal modalOption="login" />
              <RegisterModal modalOption="register" />
            </>
          )}

          {!isTabletScreen && (
            <div style={{ display: "flex" }}>
              {/* Account Section */}
              {user?.profile && <AccountButton />}

              <SearchModal />
              {isChatBoxOpen === false ? (
                <Button className="mr-5" onClick={() => updateChatBox(true)}>
                  <MESSAGE_ICON />
                </Button>
              ) : null}
            </div>
          )}
        </div>
      </div>

      {!isTabletScreen && <ChatBox isChatBox={isChatBoxOpen} setIsChatBox={updateChatBox} />}
    </StyledNavBar>
  );
};

export default NavBar;
